var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tuev-sued-status loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? [
            _c(
              "div",
              { staticClass: "tuev-sued-status__header" },
              [
                _c("h1", { staticClass: "tuev-sued-status__title" }, [
                  _vm._v(
                    "\n                TÜV SÜD Systemstatus SAP Integration\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.loadData },
                  },
                  [
                    _c("i", {
                      staticClass: "inticon-refresh",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("\n                Aktualisieren\n            "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-wrapper mb-3" },
              [
                _c(
                  "b-card",
                  { staticClass: "h-100" },
                  [
                    _c("b-card-text", [
                      _c(
                        "div",
                        { staticClass: "tuev-sued-status__overall" },
                        [
                          _c("csp-tuev-sued-status-indicator", {
                            attrs: { color: _vm.overall, size: "lg" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tuev-sued-status__overall-text" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "tuev-sued-status__overall-label",
                                },
                                [_vm._v(_vm._s(_vm.overallLabel))]
                              ),
                              _vm._v(" "),
                              _vm.overallCausingCards.length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "tuev-sued-status__overall-summary",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.overallCausingCardsSummary
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _vm._l(_vm.statusCards, function (card) {
                  return _c(
                    "b-col",
                    {
                      key: card.key,
                      staticClass: "mb-3",
                      attrs: { cols: "4" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-wrapper tuev-sued-status__status-card h-100",
                        },
                        [
                          _c(
                            "b-card",
                            {
                              staticClass: "h-100",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function () {
                                      return [
                                        _c("csp-tuev-sued-status-indicator", {
                                          attrs: {
                                            color: card.color,
                                            size: "sm",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(_vm._s(card.label)),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("b-card-text", [
                                _c("i", {
                                  class: `inticon inticon-${card.icon}`,
                                }),
                                _vm._v(" "),
                                !card.hasValue2
                                  ? _c("div", { staticClass: "card-inner-row" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "card-inner-row" }, [
                                  _c("div", { staticClass: "column" }, [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(_vm._s(card.value)),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(_vm._s(card.valueDescription)),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                card.hasValue2
                                  ? _c(
                                      "div",
                                      { staticClass: "card-inner-row" },
                                      [
                                        _c("div", { staticClass: "column" }, [
                                          _c("span", { staticClass: "bold" }, [
                                            _vm._v(_vm._s(card.value2)),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(card.value2Description)
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "8" } }, [
                  _c(
                    "div",
                    { staticClass: "card-wrapper tuev-sued-status__info-card" },
                    [
                      _c(
                        "b-card",
                        { attrs: { header: "Letzte Aktualisierung" } },
                        [
                          _c("b-card-text", [
                            _c("i", {
                              staticClass: "inticon inticon-autoclaim_info",
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-inner-row" }, [
                              _c("div", { staticClass: "column" }, [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.formatDateTime(
                                          _vm.info.lastUpdatedExportDate
                                        ) || "–"
                                      ) +
                                      "\n                                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Laufdatum und -zeit des zuletzt aktualisierten Postens"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "column" }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-inner-row" }, [
                              _c("div", { staticClass: "column" }, [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDateTime(
                                        _vm.info.lastUpdatedDate
                                      ) || "–"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Aktualisierungszeitpunkt des zuletzt aktualisierten Postens"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "column" }, [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatNumber(_vm.info.updatedLast24h)
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Anzahl aktualisierter Posten in den letzten 24h"
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }